import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  postNumberSignUp,
  registerAffiliate,
  resendOTP,
  verifyOTP,
  getAffUserCount,
  getLast5AffComm,
  getAffUserTodayPL,
  getAffUsersList,
  getUserAffCode,
  getTop5LossUsers,
  getAffUserSportWisePL,
  getAffUserCreatedCountDateWise,
  getMyAffComm,
  getAffSpecificUserSportWisePL,
  getAffBonusSetting,
} from "../../store/signUp/signUp.thunks";

export const connectAffiliate = () => (component) => {
  function mapStateToProps(state) {
    return {
      user: state.auth,
      elementsParams: state.elementsParams,
      balance: state.balance,
    };
  }

  function mapDispatchToProps(dispatch) {
    const actions = {
      postNumberSignUp,
      resendOTP,
      verifyOTP,
      registerAffiliate,
      getAffUserCount,
      getLast5AffComm,
      getAffUserTodayPL,
      getAffUsersList,
      getUserAffCode,
      getTop5LossUsers,
      getAffUserSportWisePL,
      getAffUserCreatedCountDateWise,
      getMyAffComm,
      getAffSpecificUserSportWisePL,
      getAffBonusSetting,
    };

    return { actions: bindActionCreators(actions, dispatch) };
  }

  return connect(mapStateToProps, mapDispatchToProps)(component);
};
